import React from 'react';
import { HTTP } from 'meteor/http';
import { Session } from 'meteor/session';
import moment from 'moment'; 

export class Weather extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.verify(props.date);
    }

	componentWillReceiveProps({ date }) {
		this.verify(date);
	}

    verify(date) {
		if(Session.get(this.props.date)) {
			this.setState({
				sunrise : moment(Session.get(this.props.date).sunrise).format('kk:mm'),
				sunset : moment(Session.get(this.props.date).sunset).format('kk:mm')
			});
		} else {
			this.get(date);
		}
    }

	get(date) {
		let self = this;
		HTTP.call( 'GET', 'https://api.sunrise-sunset.org/json?lat=47.478419&lng=-0.563166&formatted=0&date=' + date, {}, (error, response) => {
			if (error)
				return console.error("Failed to fetch weather", error);

	        self.set(response.data.results);
		});
	}

	set(data) {
		Session.setDefault(this.props.date, data);
		this.setState({
			sunrise : moment(data.sunrise).format('kk:mm'),
			sunset : moment(data.sunset).format('kk:mm')
		});
	}

	render() {
		if (this.state.sunrise) {
			return (
				<small>( {this.state.sunrise} - {this.state.sunset} )</small>
			);
		} else {
			return (<small>-</small>);
		}
	}

}



/** WEBPACK FOOTER **
 ** ./src/universal/external_api/weather.js
 **/